/**
 * Featured Locations Data
 *
 * This file contains the featured locations displayed on the home page in the S34Dropdowns component.
 * Update this data to change which locations are featured and their associated links.
 */

export interface LocationLink {
    label: string;
    href: string;
}

export interface LocationColumn {
    state: string;
    locations: LocationLink[];
}

export const featuredLocations: LocationColumn[] = [
    {
        state: 'Texas',
        locations: [
            { label: 'Laser Hair Removal in Houston, TX', href: '/locations/tx/houston' },
            {
                label: 'Laser Hair Removal in San Antonio West, TX',
                href: '/locations/tx/san-antonio/9123-n-loop-1604-w',
            },
            { label: 'Laser Hair Removal in Northeast Dallas, TX', href: '/locations/tx/dallas/6464-e-nw-hwy' },
            { label: 'Laser Hair Removal in Houston Galleria, TX', href: '/locations/tx/houston/5785-san-felipe-st' },
            {
                label: 'Laser Hair Removal in San Antonio, TX',
                href: '/locations/tx/san-antonio/834-northwest-loop-410',
            },
            { label: 'Laser Hair Removal in San Antonio, TX', href: '/locations/tx/san-antonio' },
            { label: 'Laser Hair Removal in Denton, TX', href: '/locations/tx/dallas/1800-s-loop-288' },
            { label: 'Laser Hair Removal in Irving, TX', href: '/locations/tx/dallas/7600-n-macarthur-blvd' },
            { label: 'Laser Hair Removal in Webster, TX', href: '/locations/tx/houston/1501-west-bay-area-blvd' },
            { label: 'Laser Hair Removal in Flower Mound, TX', href: '/locations/tx/dallas/6050-long-prairie-rd-300' },
        ],
    },
    {
        state: 'Illinois',
        locations: [
            { label: 'Laser Hair Removal in Bucktown, IL', href: '/locations/il/chicago/2659-north-elston-ave' },
            { label: 'Laser Hair Removal in Chicago, IL', href: '/locations/il/chicago' },
            { label: 'Laser Hair Removal in Aurora, IL', href: '/locations/il/chicago/503-south-illinois-rte-59' },
            { label: 'Laser Hair Removal in Crystal Lake, IL', href: '/locations/il/chicago/5899-northwest-hwy-c' },
            { label: 'Laser Hair Removal in Gurnee, IL', href: '/locations/il/chicago/6941-grand-avenue' },
        ],
    },
    {
        state: 'Florida',
        locations: [
            { label: 'Laser Hair Removal in Miami, FL', href: '/locations/fl/miami' },
            {
                label: 'Laser Hair Removal in Fort Myers, FL',
                href: '/locations/fl/fort-myers/11741-south-cleveland-ave',
            },
            { label: 'Laser Hair Removal in Doral, FL', href: '/locations/fl/miami/8484-nw-36th-street' },
            { label: 'Laser Hair Removal in Fort Myers, FL', href: '/locations/fl/fort-myers' },
            { label: 'Laser Hair Removal in Miami Beach, FL', href: '/locations/fl/miami/1523-alton-road' },
        ],
    },
    {
        state: 'Arizona',
        locations: [
            { label: 'Laser Hair Removal in Scottsdale South, AZ', href: '/locations/az/phoenix/4390-n-miller-rd' },
            { label: 'Laser Hair Removal in Gilbert, AZ', href: '/locations/az/phoenix/1815-e-williams-field-rd' },
            { label: 'Laser Hair Removal in Mesa, AZ', href: '/locations/az/phoenix/1325-n-greenfield-rd' },
            {
                label: 'Laser Hair Removal in Scottsdale North, AZ',
                href: '/locations/az/phoenix/13802-n-scottsdale-rd',
            },
            { label: 'Laser Hair Removal in Phoenix, AZ', href: '/locations/az/phoenix' },
        ],
    },
    {
        state: 'Michigan',
        locations: [
            { label: 'Laser Hair Removal in Dearborn Heights, MI', href: '/locations/mi/detroit/26661-ford-rd' },
            { label: 'Laser Hair Removal in Rochester Hills, MI', href: '/locations/mi/detroit/125-s-livernois-rd' },
            { label: 'Laser Hair Removal in Novi, MI', href: '/locations/mi/detroit/43430-w-oaks-dr' },
            { label: 'Laser Hair Removal in Detroit, MI', href: '/locations/mi/detroit' },
        ],
    },
    {
        state: 'Minnesota',
        locations: [
            { label: 'Laser Hair Removal in Edina, MN', href: '/locations/mn/minneapolis-st-paul/6807a-york-ave-s' },
            {
                label: 'Laser Hair Removal in St. Paul, MN',
                href: '/locations/mn/minneapolis--st-paul/735-cleveland-ave-s',
            },
            {
                label: 'Laser Hair Removal in Minnetonka, MN',
                href: '/locations/mn/minneapolis--st-paul/14200-w-wayzata-blvd',
            },
        ],
    },
    {
        state: 'Missouri',
        locations: [
            { label: 'Laser Hair Removal in Overland Park, MO', href: '/locations/mo/kansas-city/9666-quivira-rd' },
            { label: 'Laser Hair Removal in Kansas City, MO', href: '/locations/mo/kansas-city' },
        ],
    },
    {
        state: 'Massachusetts',
        locations: [
            { label: 'Laser Hair Removal in Peabody, MA', href: '/locations/ma/boston/9-sylvan-st' },
            { label: 'Laser Hair Removal in Dedham, MA', href: '/locations/ma/boston/715-providence-hwy' },
        ],
    },
    {
        state: 'Utah',
        locations: [{ label: 'Laser Hair Removal in Sandy, UT', href: '/locations/ut/salt-lake-city/10481-state-st' }],
    },
    {
        state: 'Georgia',
        locations: [{ label: 'Laser Hair Removal in Atlanta, GA', href: '/locations/ga/atlanta' }],
    },
    {
        state: 'Wisconsin',
        locations: [
            { label: 'Laser Hair Removal in Milwaukee, WI', href: '/locations/wi/milwaukee' },
            { label: 'Laser Hair Removal in Madison, WI', href: '/locations/wi/madison' },
            { label: 'Laser Hair Removal in Green Bay, WI', href: '/locations/wi/green-bay' },
        ],
    },
    {
        state: 'New York',
        locations: [
            { label: 'Laser Hair Removal in Buffalo, NY', href: '/locations/ny/buffalo' },
            { label: 'Laser Hair Removal in Rochester, NY', href: '/locations/ny/rochester' },
            { label: 'Laser Hair Removal in Syracuse, NY', href: '/locations/ny/syracuse' },
            { label: 'Laser Hair Removal in Binghamton, NY', href: '/locations/ny/binghamton' },
        ],
    },
    {
        state: 'Ohio',
        locations: [
            { label: 'Laser Hair Removal in Cleveland, OH', href: '/locations/oh/cleveland' },
            { label: 'Laser Hair Removal in Cincinnati, OH', href: '/locations/oh/cincinnati' },
            { label: 'Laser Hair Removal in Toledo, OH', href: '/locations/oh/toledo' },
            { label: 'Laser Hair Removal in Columbus, OH', href: '/locations/oh/columbus' },
        ],
    },
    {
        state: 'North Carolina',
        locations: [
            { label: 'Laser Hair Removal in Charlotte, NC', href: '/locations/nc/charlotte' },
            { label: 'Laser Hair Removal in Raleigh, NC', href: '/locations/nc/raleigh' },
            { label: 'Laser Hair Removal in Greensboro, NC', href: '/locations/nc/greensboro' },
            { label: 'Laser Hair Removal in Durham, NC', href: '/locations/nc/durham' },
        ],
    },
    {
        state: 'Pennsylvania',
        locations: [
            { label: 'Laser Hair Removal in Pittsburgh, PA', href: '/locations/pa/pittsburgh' },
            { label: 'Laser Hair Removal in Philadelphia, PA', href: '/locations/pa/philadelphia' },
            { label: 'Laser Hair Removal in Erie, PA', href: '/locations/pa/erie' },
        ],
    },
];
